;(function() {
  const threshold = 60
  const section_count = 6

  const ACTIVE = 'active'

  const APP_TARGET = '#product-merchant-list'
  let appTarget;

  const isBlank = (str) => {
    return (typeof str === 'undefined' || str === null || !str.trim());
  }

  const getState = () => {
    return JSON.parse(appTarget.getAttribute('data-state')) || [null, null]
  }

  // Passing in a state of [null, null] maintains the status quo
  const setState = (passedState = [null, null]) => {
    const [newGroupLink, newCityLink] = passedState
    const [oldGroupLink, oldCityLink] = getState()
    let interimState = getState()

    if ( !isBlank(newGroupLink) && newGroupLink === oldGroupLink ) {
      interimState = [null, null]
    } else if ( !isBlank(newGroupLink) )  {
      interimState = [newGroupLink, null]
    }

    if ( !isBlank(newCityLink) && newCityLink === oldCityLink ) {
      interimState[1] = null
    } else if ( !isBlank(newCityLink) )  {
      interimState[1] = newCityLink
    }

    console.log(`state is: ${[...interimState]}`)
    appTarget.setAttribute('data-state', JSON.stringify([...interimState]))
  }

  const render = () => {
    appTarget.querySelectorAll(`.${ACTIVE}`).forEach(active => active.classList.remove(ACTIVE))

    const [groupLink, cityLink] = getState()

    if (!isBlank(groupLink)) {
      appTarget
          .querySelectorAll(`[data-group="${groupLink}"]`)
          .forEach(groupLink => groupLink.classList.add(ACTIVE))
    }

    if (!isBlank(cityLink)) {
      appTarget
          .querySelectorAll(`[data-group="${cityLink}"]`)
          .forEach(cityLink => cityLink.classList.add(ACTIVE))
    }

    scrollToGroup(groupLink, cityLink)
  }

  const buildProductMerchantList = function({ cities }) {
    const productMerchantList = document.querySelector(APP_TARGET)

    if ( !cities || cities.length <= 0 ) return

    if (cities.length >= threshold) {
     productMerchantList.classList.add('threshold-breached')
    }

    const cityGroupLinks = document.createElement('section')
          cityGroupLinks.setAttribute('id', 'city-groups-links')

    productMerchantList.appendChild(cityGroupLinks)

    const groups = buildCityGroups(cities)

    groups.forEach((cityList, gidx) => {

      const groupLinkAnchor = document.createElement('a')
            groupLinkAnchor.classList.add('group-link', 'city-group-link')
            groupLinkAnchor.setAttribute('id', `city-group-link-${gidx}`)
            groupLinkAnchor.setAttribute('data-group', gidx)
            groupLinkAnchor.setAttribute('href', `#city-group-${gidx}`)
            groupLinkAnchor.textContent = `${cityList[0].name} - ${cityList[cityList.length-1].name}`

      cityGroupLinks.appendChild(groupLinkAnchor.cloneNode(true))
      productMerchantList.appendChild(groupLinkAnchor)

      const cityGroup = document.createElement('div')
            cityGroup.setAttribute('id', `city-group-${gidx}`)
            cityGroup.setAttribute('data-group', gidx)
            cityGroup.classList.add('group', 'city-group')

      productMerchantList.appendChild(cityGroup)

      cityList.forEach((city, cidx) => {

        const cityAnchor = document.createElement('a')
              cityAnchor.classList.add('group-link', 'city-link')
              cityAnchor.setAttribute('id', `#city-link-${gidx}-${cidx}`)
              cityAnchor.setAttribute('data-group', `${gidx}-${cidx}`)
              cityAnchor.setAttribute('href', `#merchant-group-${gidx}-${cidx}`)
              cityAnchor.textContent = city.name

        cityGroup.appendChild(cityAnchor)

        const merchantGroup = document.createElement('div')
              merchantGroup.classList.add('group', 'merchant-group')
              merchantGroup.setAttribute('data-group', `${gidx}-${cidx}`)
              merchantGroup.setAttribute('id', `merchant-group-${gidx}-${cidx}`)

        const merchantGroupHeader = document.createElement('header')
              merchantGroupHeader.textContent = `Save up to 50% at these businesses in ${city.name}`

        merchantGroup.appendChild(merchantGroupHeader)

        city.merchants.reverse().forEach(merchant => {
          const merchantElem = document.createElement('div')
                merchantElem.classList.add('merchant')
                merchantElem.setAttribute('id', merchant.id)
                merchantElem.textContent = merchant.name

          if ( merchant.is_book ) merchantElem.setAttribute('data-is-book', '')
          if ( merchant.is_digital ) merchantElem.setAttribute('data-is-digital', '')

          merchantGroup.appendChild(merchantElem)
        })

        const merchantGroupFooter = document.createElement('footer')
              merchantGroupFooter.classList.add('merchant-legend')
              merchantGroupFooter.innerHTML = `
                <div><i class='fal fa-book fa-sm'></i>BOOK ONLY</div>
                <div><i class='fal fa-mobile fa-sm'></i><i class='fal fa-desktop-alt fa-sm'></i>DIGITAL ONLY</div>
                <div><i class='fal fa-book fa-sm'></i><i class='fal fa-mobile fa-sm'></i><i class='fal fa-desktop-alt fa-sm'></i>BOOK AND DIGITAL</div>
              `

        merchantGroup.appendChild(merchantGroupFooter)

        const topAnchor = document.createElement('template');
        topAnchor.innerHTML = `
          <a class="city-top topanchor" data-scroll href="#merchant-list-head">
            <i class="fa fa-chevron-up" aria-hidden="true"></i>
            <br/>
            <span class="top-link">Top of Cities</span>
          </a>`

        merchantGroup.appendChild(topAnchor.content)

        productMerchantList.appendChild(merchantGroup)
      })

      /*
      if ( !threshold_breached ) {
        forceState(['0', null])
      }
      */
    })

  }

  const buildCityGroups = (cities) => {
    cities.reduce((list, city) => {
      return (city.name && city.merchants && city.merchants.length > 0) ? [...list, city] : list
    }, [])

    if (cities && cities.length <= 0) {
      console.error('Could not get a list of cities')
      return
    }

    let threshold_breached = (cities.length >= threshold)

    let groups = [[]]
    if (threshold_breached) {
      groups = Array.from(new Array(section_count), () => [])
    }

    const min_size = Math.floor(cities.length / groups.length)

    let current_section = 0
    let saturated = false

    cities.sort((a, b) => a.name.localeCompare(b.name))

    cities.forEach(city => {
      if ( min_size <= groups[current_section].length) {
        if ( saturated ) {
          current_section++
          saturated = false
        } else {
          saturated = true
        }
      }
      groups[current_section].push(city)
    })

    return groups.filter(group => group && group.length > 0)
  }

  const mutationCallback = function(mutationsList) {
    console.log(mutationsList)
    mutationsList.forEach(mutation => {
      if ( mutation.type === 'attributes' ) {
        if (mutation.attributeName === 'data-state') render()
      }
    })
  }

  const scrollIntoViewOptions = {
    behavior: 'smooth',
  }

  const getHeaderHeight = function() {
    const fixedElement = document.querySelector('nav#navbar')
    if (!fixedElement) return 0
    return fixedElement.offsetHeight
  }

  const scroll = function(linkElement) {
    if (!linkElement) return
    const targetElement = document.querySelector(linkElement.getAttribute('href'))
    if (!targetElement) return
    targetElement.scrollIntoView(scrollIntoViewOptions)
    targetElement.scrollTop = getHeaderHeight()
  }

  const scrollToGroup = function(groupLinkId, cityLinkId) {
    if ((typeof cityLinkId === 'string') && cityLinkId.length > 0) {
      const linkElement = document.querySelector(`a[data-group="${cityLinkId}"]`)
      scroll(linkElement)
      return
    }

    if ((typeof groupLinkId === 'string') && groupLinkId.length > 0) {
      const linkElement = document.querySelector(`a[data-group="${groupLinkId}"]`)
      scroll(linkElement)
      return
    }
  }

  document.addEventListener("DOMContentLoaded", async function() {
    appTarget = document.querySelector(APP_TARGET)

    const observer = new MutationObserver(mutationCallback)
    observer.observe(appTarget, { attributeFilter: ['data-state'] })

    const mappingJsonUri = document.querySelector('#mapping_json_url').getAttribute('value')
    const response = await fetch(mappingJsonUri).catch(error => console.error(error))

    if ( response ) { console.debug(`Loaded: '${mappingJsonUri}'`)}
    else { console.error(`Couldn't load: '${mappingJsonUri}'`)}

    const { market } = await response.json()

    buildProductMerchantList(market)

    appTarget.querySelectorAll('.city-group-link').forEach(cityGroupLink => {
      cityGroupLink.addEventListener('click', event => {
        event.preventDefault()
        setState([cityGroupLink.getAttribute('data-group'), null])

      })
    })

    appTarget.querySelectorAll('.city-link').forEach(cityLink => {
      cityLink.addEventListener('click', event => {
        event.preventDefault()
        setState([null, cityLink.getAttribute('data-group')])
        const targetElementId = cityLink.getAttribute('href');
        const targetElement = document.querySelector(targetElementId)
        scrollToElement(targetElement)
      })
    })

    render()
  })
})()